export const americanStates = [
    {
        "name": "Alabama",
        "isoCode": "AL"
    },
    {
        "name": "Alaska",
        "isoCode": "AK"
    },
    {
        "name": "American Samoa",
        "isoCode": "AS"
    },
    {
        "name": "Arizona",
        "isoCode": "AZ"
    },
    {
        "name": "Arkansas",
        "isoCode": "AR"
    },
    {
        "name": "California",
        "isoCode": "CA"
    },
    {
        "name": "Colorado",
        "isoCode": "CO"
    },
    {
        "name": "Connecticut",
        "isoCode": "CT"
    },
    {
        "name": "Delaware",
        "isoCode": "DE"
    },
    {
        "name": "District Of Columbia",
        "isoCode": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "isoCode": "FM"
    },
    {
        "name": "Florida",
        "isoCode": "FL"
    },
    {
        "name": "Georgia",
        "isoCode": "GA"
    },
    {
        "name": "Guam",
        "isoCode": "GU"
    },
    {
        "name": "Hawaii",
        "isoCode": "HI"
    },
    {
        "name": "Idaho",
        "isoCode": "ID"
    },
    {
        "name": "Illinois",
        "isoCode": "IL"
    },
    {
        "name": "Indiana",
        "isoCode": "IN"
    },
    {
        "name": "Iowa",
        "isoCode": "IA"
    },
    {
        "name": "Kansas",
        "isoCode": "KS"
    },
    {
        "name": "Kentucky",
        "isoCode": "KY"
    },
    {
        "name": "Louisiana",
        "isoCode": "LA"
    },
    {
        "name": "Maine",
        "isoCode": "ME"
    },
    {
        "name": "Marshall Islands",
        "isoCode": "MH"
    },
    {
        "name": "Maryland",
        "isoCode": "MD"
    },
    {
        "name": "Massachusetts",
        "isoCode": "MA"
    },
    {
        "name": "Michigan",
        "isoCode": "MI"
    },
    {
        "name": "Minnesota",
        "isoCode": "MN"
    },
    {
        "name": "Mississippi",
        "isoCode": "MS"
    },
    {
        "name": "Missouri",
        "isoCode": "MO"
    },
    {
        "name": "Montana",
        "isoCode": "MT"
    },
    {
        "name": "Nebraska",
        "isoCode": "NE"
    },
    {
        "name": "Nevada",
        "isoCode": "NV"
    },
    {
        "name": "New Hampshire",
        "isoCode": "NH"
    },
    {
        "name": "New Jersey",
        "isoCode": "NJ"
    },
    {
        "name": "New Mexico",
        "isoCode": "NM"
    },
    {
        "name": "New York",
        "isoCode": "NY"
    },
    {
        "name": "North Carolina",
        "isoCode": "NC"
    },
    {
        "name": "North Dakota",
        "isoCode": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "isoCode": "MP"
    },
    {
        "name": "Ohio",
        "isoCode": "OH"
    },
    {
        "name": "Oklahoma",
        "isoCode": "OK"
    },
    {
        "name": "Oregon",
        "isoCode": "OR"
    },
    {
        "name": "Palau",
        "isoCode": "PW"
    },
    {
        "name": "Pennsylvania",
        "isoCode": "PA"
    },
    {
        "name": "Puerto Rico",
        "isoCode": "PR"
    },
    {
        "name": "Rhode Island",
        "isoCode": "RI"
    },
    {
        "name": "South Carolina",
        "isoCode": "SC"
    },
    {
        "name": "South Dakota",
        "isoCode": "SD"
    },
    {
        "name": "Tennessee",
        "isoCode": "TN"
    },
    {
        "name": "Texas",
        "isoCode": "TX"
    },
    {
        "name": "Utah",
        "isoCode": "UT"
    },
    {
        "name": "Vermont",
        "isoCode": "VT"
    },
    {
        "name": "Virgin Islands",
        "isoCode": "VI"
    },
    {
        "name": "Virginia",
        "isoCode": "VA"
    },
    {
        "name": "Washington",
        "isoCode": "WA"
    },
    {
        "name": "West Virginia",
        "isoCode": "WV"
    },
    {
        "name": "Wisconsin",
        "isoCode": "WI"
    },
    {
        "name": "Wyoming",
        "isoCode": "WY"
    }
];

export const pdx_StateRequiredCountries: string[] = ['United States', 'Canada', 'Australia', 'Ukraine']
